import { computed, inject, Injectable, signal } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
	providedIn: 'root',
})
export class LanguageService {
	private translate = inject(TranslateService)
	readonly #currentLang = signal<'fa' | 'en' | 'ar'>('fa')
	readonly dir = computed(() => (this.#currentLang() === 'fa' || this.#currentLang() === 'ar' ? 'rtl' : 'ltr'))

	constructor() {
		const translate = this.translate

		translate.addLangs(['en', 'fa', 'ar'])
		translate.setFallbackLang(this.#currentLang())
		this.setLanguage(this.#currentLang())
	}

	setLanguage(lang: 'fa' | 'en' | 'ar') {
		this.#currentLang.set(lang)
		this.translate.use(lang)
		// SSR guard: `document` is unavailable on the server.
		if (typeof document !== 'undefined') {
			document.documentElement.dir = this.dir()
		}
	}

	get currentLanguage() {
		return this.#currentLang.asReadonly()
	}
}
